import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { Section, Container, Title, Background } from '../../components/page'
import { BlogPostCard, BlogPostGrid } from '../../components/blog'

import * as styles from './dont-miss-out.module.scss'
import { Buttons, LinkButton } from '../../components/button'

export type DontMissOutProps = Queries.DontMissOutFragment

export const DontMissOut = ({ title, buttons }: DontMissOutProps) => {
  const data = useStaticQuery<Queries.DontMissOutStaticQuery>(graphql`
    query DontMissOutStatic {
      blogPosts: allContentfulBlogPost(
        sort: { publishDate: DESC }
        limit: 3
        skip: 0
      ) {
        nodes {
          ...BlogPostItem
        }
      }
    }
  `)

  return (
    <Section className={styles.section}>
      <Container>
        <Title className={styles.title}>{title}</Title>
        <BlogPostGrid>
          {data.blogPosts.nodes.map((post) => (
            <BlogPostCard key={post.id} post={post} />
          ))}
        </BlogPostGrid>
        <Buttons className={styles.buttons}>
          {buttons?.map((item, index) => (
            <LinkButton
              key={item?.id}
              color={index === 0 ? 'primary' : 'secondary'}
              variant={index === 0 ? 'border' : null}
              link={item}
            >
              {item?.title}
            </LinkButton>
          ))}
        </Buttons>
      </Container>
      <Background variant="dontmissout" />
    </Section>
  )
}

export const DontMissOutFragments = graphql`
  fragment DontMissOut on ContentfulDontMissOut {
    __typename
    id
    title
    buttons {
      ...Link
    }
  }
`
